import Openable from './lib/openable';

export default class extends Openable {
  protected getActiveClass() {
    return 'v2-modal--active';
  }
}
